import React from "react";
import { IconButton } from "../controls/TooltipControls";
import { close, minimize, toggleMaximize, useIsMaximized, } from "../hooks/windowControls";
export const WindowControls = () => {
    const isMaximized = useIsMaximized();
    return (React.createElement("div", { id: "window-controls" },
        React.createElement(IconButton, { className: "window-control", icon: "window-minimize", id: "window-minimize", tooltip: "", onClick: minimize }),
        React.createElement(IconButton, { className: "window-control", icon: isMaximized ? "window-restore" : "window-maximize", id: "window-maximize", tooltip: "", onClick: toggleMaximize }),
        React.createElement(IconButton, { className: "window-control", icon: "window-close", id: "window-close", tooltip: "", onClick: close })));
};
export default WindowControls;
